import { render, staticRenderFns } from "./product12.vue?vue&type=template&id=636b59eb&scoped=true"
import script from "./product12.vue?vue&type=script&lang=js"
export * from "./product12.vue?vue&type=script&lang=js"
import style0 from "./product12.vue?vue&type=style&index=0&id=636b59eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636b59eb",
  null
  
)

export default component.exports